import AdebifyReducer from './reducers';

export default AdebifyReducer;
